import { render, staticRenderFns } from "./ContentGridLibraries.vue?vue&type=template&id=4e0a3e80"
import script from "./ContentGridLibraries.vue?vue&type=script&lang=js"
export * from "./ContentGridLibraries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports